import { LayerDefinition } from './types';

export const precipDefinition: LayerDefinition = {
  id: 'precip',
  name: 'Precipitation Accumulation',
  category: 'core_met',
  categoryLabel: 'Core Meteorological',
  icon: '🌧️',
  description: 'Hourly precipitation rates & 24h/48h rain & snow accumulation forecasts.',
  sourceModels: ['nbm', 'rdps', 'ecmwf', 'gfs', 'hrrr', 'icon13', 'blend', 'MRMS (Obs)'],
  outputModels: ['Precip rate & 24h Rain/Snow accumulation .pmtiles per model'],
  config: {
    views: ['hourly', 'prob', '24h_rain', '24h_snow'],
    defaultView: 'hourly',
    defaultModel: 'nbm'
  }
};

export default precipDefinition;
